import { chapter1sub1, chapter1sub2, chapter1sub3, chapter1sub4, chapter1sub5, chapter1sub6, chapter1sub7, chapter1sub8, chapter1sub9 } from './chapter1/index'

const books = {
  // 书籍的基本信息
  basic: {
    title: '新时代大学英语——综合教程2',
    cover: require('@/assets/images/books/book2/book-cover.png'),
    judge: '主审 张森',
    editor: '主编 丁国声 滕婷婷 刘学',
  },
  // 书籍的目录 需要与内容对应以获取定位
  catalogue: [
    {
      key: 'chapter1',
      name: 'UNIT 4 Celebrating Festivals',
      children: [
        {
          key: 'chapter1sub1',
          firstChildKey: 'section1',
          name: 'Lead-in',
        },
        {
          key: 'chapter1sub2',
          firstChildKey: 'section1.3',
          name: 'Listening and Speaking',
        },
        {
          key: 'chapter1sub3',
          firstChildKey: 'section3',
          name: 'Enriching Your Ideas Text A',
        },
        {
          key: 'chapter1sub10',
          firstChildKey: 'section2',
          name: 'Enriching Your Ideas Text B',
          isLock: true,
        },
        {
          key: 'chapter1sub4',
          firstChildKey: 'section4.0',
          name: 'Translation',
        },
        {
          key: 'chapter1sub5',
          firstChildKey: 'section5',
          name: 'How to Write',
        },
        {
          key: 'chapter1sub6',
          firstChildKey: 'section6',
          name: 'Vocational Focus',
        },
        {
          key: 'chapter1sub7',
          firstChildKey: 'section7',
          name: 'Self-Regulated Learning',
        },
        {
          key: 'chapter1sub8',
          firstChildKey: 'section8',
          name: 'Chinese Wisdom',
        },
        {
          key: 'chapter1sub9',
          firstChildKey: 'section9.0',
          name: 'Evaluation',
        },
      ],
    },
  ],
  // 图书内容
  content: {
    chapter1sub1,
    chapter1sub2,
    chapter1sub3,
    chapter1sub4,
    chapter1sub5,
    chapter1sub6,
    chapter1sub7,
    chapter1sub8,
    chapter1sub9,
    chapter1sub10: [],
  },
  // 图书下载文件
  fileDownload: [],
}
export default books